export default function() {
  var self = this;

  self.$el = $('#invite_user');
  self.$nameSearchEl = $('#user_search_first_name, #user_search_last_name');
  self.$emailSearchEl = $('#user_search_email');

  self.selectedUser = ko.observable({
    first_name: ko.observable(),
    last_name: ko.observable(),
    email: ko.observable(),
    roles: ko.observableArray('')
  });

  self.initUI = () => {
    self.initTypeaheads();
  };

  self.inviteUser = function(item, event) {
    self.client_errors = ko.validation.group(self.selectedUser(), { deep: true });
    if (self.client_errors().length === 0) {
      self.sendInvitation();
    } else {
      self.client_errors.showAllMessages();
    }
  };

  self.selectedUser.subscribe(self.resetSelectedUser);

  this.initSearchEngine = type => {
    const statusIndicatorEl = document.querySelector('.status_indicator')

    const userSearch = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace(type),
      queryTokenizer: Bloodhound.tokenizers.whitespace,

      limit: 5,

      remote: {
        url: Kadenze.Routes.list_admin_users_path({ q: '%QUERY', type }),

        filter: users => {
          return users.map(user => {
            return {
              name: user.first_name + ' ' + user.last_name,
              first_name: user.first_name,
              last_name: user.last_name,
              email: user.email.trim(),
              role: self.selectedUser().roles(),
            };
          });
        },

        ajax: {
          dataType: 'json',
          contentType: 'application/json',
          beforeSend: () => statusIndicatorEl.innerHTML = 'Searching...',
          complete: () => statusIndicatorEl.innerHTML = '',
        }
      }
    });

    userSearch.initialize();

    return userSearch;
  };

  self.initTypeahead = ($element, key) => {
    const searchEngine = self.initSearchEngine(key);

    $element.typeahead({
      hint: false,
      highlight: true,
      minLength: 1
    },
    {
      name: 'users',
      displayKey: key,
      source: searchEngine.ttAdapter()
    });

    $element.on('typeahead:selected', self.resultsSelected);
  };

  self.resultsSelected = (obj, { first_name, last_name, email, role }) => {
    self.selectedUser().first_name(first_name);
    self.selectedUser().last_name(last_name);
    self.selectedUser().email(email);
    self.selectedUser().roles(role);
  };


  self.initTypeaheads = () => {
    this.initTypeahead(this.$nameSearchEl, 'name');
    this.initTypeahead(this.$emailSearchEl, 'email');
  };

  self.resetSelectedUser = function() {
    self.client_errors = ko.validation.group(self.selectedUser(), { deep: true });
    self.selectedUser().first_name('');
    self.selectedUser().last_name('');
    self.selectedUser().email('');
    $('#global_role').val('').selectpicker('refresh');
    self.client_errors.showAllMessages(false);
  };

  self.sendInvitation = function() {
    var req = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.admin_users_path(),
      data: { user: ko.mapping.toJS(self.selectedUser()) }
    });

    req.done(function(res) {
      new Kadenze.Notice.success({message: res.message});
      self.resetSelectedUser();
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.errors;
      }
      new Kadenze.Notice.error({message: msg});
    });
  };

  const __construct = function(that) {
    console.log('constructor called for AdminUserInviteViewModel');
  }(this);
}
